<template>
	<div>
		<el-card>
			<el-form :model="form" ref="form">
				<el-form-item label="订单编号:">
					<el-input placeholder="请输入订单编号" v-model="form.orderid" style="width: 350px;"></el-input>
				</el-form-item>
				<el-form-item label="流水日期:">
					<el-date-picker v-model="form.time" type="daterange" range-separator="至" start-placeholder="开始日期"
						end-placeholder="结束日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitForm()">查询</el-button>
					<el-button @click="resetForm()">重置</el-button>
				</el-form-item>
			</el-form>
			<div class="runmoney">
				<ul>
					<li>
						<h4>收入金额（元） </h4>
						<h2>{{moneyform.incomemoney}}</h2>
					</li>
					<!-- <li>
						<h4></h4>
						<h2>=</h2>
					</li> -->
					<li>
						<h4>流水金额（元） </h4>
						<h2>{{moneyform.runwater}}</h2>
					</li>
					<!-- <li>
						<h4> </h4>
						<h2>-</h2>
					</li> -->
					<li>
						<h4>支出金额（元） </h4>
						<h2>{{moneyform.paymoney}}</h2>
					</li>
				</ul>
				
			</div>
		</el-card>
		<el-card>
			<el-table :data="tableData" style="width: 100%">
				<el-table-column type="index" width="50">
				</el-table-column>
				<el-table-column prop="id" label="流水ID" >
				</el-table-column>
				<el-table-column prop="uid" label="用户ID" >
				</el-table-column>
				<el-table-column prop="enter_name" label="用户实名" >
				</el-table-column>
				<el-table-column prop="nickname" label="用户昵称" width="180">
				</el-table-column>
				<el-table-column prop="order_num" label="流水编号" width="180">
				</el-table-column>
				<el-table-column prop="price" label="流水金额" width="180" >
					<template slot-scope="scope">
						<!-- 平台收入绿色 加号 平台支付红色减号 -->
						<!-- <div style="color: red;" v-if="scope.row.type.includes(1)">{{scope.row.price}} -</div>
						<div v-else style="color: green;">{{scope.row.price}} +</div> -->
						<div style="color: red;" v-if="scope.row.type == 1">{{scope.row.price}} -</div>
						<div style="color: red;" v-else-if="scope.row.type == 8">{{scope.row.price}} -</div>
						<div style="color: red;" v-else-if="scope.row.type == 4">{{scope.row.price}} -</div>
						<div style="color: red;" v-else-if="scope.row.type == 5">{{scope.row.price}} -</div>
						<div style="color: red;" v-else-if="scope.row.type == 17">{{scope.row.price}} -</div>
						<div style="color: red;" v-else-if="scope.row.type == 15">{{scope.row.price}} -</div>
						<div style="color: green;" v-else-if="scope.row.type == 0">{{scope.row.price}} +</div>
						<div style="color: green;" v-else-if="scope.row.type == 2">{{scope.row.price}} +</div>
						<div style="color: green;" v-else-if="scope.row.type == 6">{{scope.row.price}} +</div>
						<div style="color: green;" v-else-if="scope.row.type == 9">{{scope.row.price}} +</div>
						<div style="color: green;" v-else-if="scope.row.type == 11">{{scope.row.price}} +</div>
						<div style="color: green;" v-else-if="scope.row.type == 13">{{scope.row.price}} +</div>
						<div style="color: green;" v-else-if="scope.row.type == 14">{{scope.row.price}} +</div>
						<div style="color: green;" v-else-if="scope.row.type == 16">{{scope.row.price}} +</div>
						<div style="color: green;" v-else-if="scope.row.type == 19">{{scope.row.price}} +</div>
						<div v-else >{{scope.row.price}} </div>
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="流水备注" width="180">
				</el-table-column>
				<el-table-column  label="流水状态" width="180">
					<template slot-scope="scope">
						<div v-if="scope.row.state == 1">
							已完成
						</div>
						<div v-else>
							进行中
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="start_time" label="收益时间" width="180">
				</el-table-column>
			</el-table>
			<Pageing :page="page" :size="size" :total="total" @current-change="handleChangePage"></Pageing>
		</el-card>
		
		<el-dialog title="详情信息" :visible.sync="dialogFormVisible">
		  <el-form :model="forminfo">
		    <el-form-item label="订单编号" :label-width="formLabelWidth">
		      <el-input v-model="forminfo.order_num" disabled autocomplete="off"></el-input>
		    </el-form-item>
			<el-form-item label="用户昵称" :label-width="formLabelWidth">
			  <el-input v-model="forminfo.nickname" disabled autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="真实姓名" :label-width="formLabelWidth">
			  <el-input v-model="forminfo.enter_name" disabled autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="身份证号" :label-width="formLabelWidth">
			  <el-input v-model="forminfo.user_idcard" disabled autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="收益金额" :label-width="formLabelWidth">
			  <el-input v-model="forminfo.price" disabled autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="收益时间" :label-width="formLabelWidth">
			  <el-input v-model="forminfo.start_time" disabled autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="备注" :label-width="formLabelWidth">
			  <el-input v-model="forminfo.remark" disabled autocomplete="off"></el-input>
			</el-form-item>
			
		    
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="dialogFormVisible = false">取 消</el-button>
		    <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	import Pageing from '../../components/page/page.vue'
	import {
		getrunwaterList
	} from '../../api/board.js'
	export default {
		components: {
			Pageing
		},
		data() {
			return {
				formLabelWidth: '120px',
				dialogFormVisible:false,
				page:1,
				size:10,
				total:0,
				tableData: [],
				runmoney:0,
				checkAll: false,
				form: {
					orderid: '',
					time: '',
				},
				moneyform:{
					incomemoney:0,
					runwater:0,
					paymoney:0,
				},
				forminfo:{},
			};
		},
		mounted() {
			this.getuserlist()
		},
		computed: {
			isincome(e){
				console.log(e);
				return true;
			}
		},
		methods: {
			resetForm(){
				this.form.orderid =''
				this.form.time =''
				this.getuserlist()
			},
			getuserlist(){
				getrunwaterList({
					page:this.page,
					where:this.form
				}).then(res=>{
					this.moneyform = res.moneyform
					this.tableData = res.list.data
					this.total = res.list.total 
					
				})
				
			},
			handinfo(e){
				console.log(e);
				this.dialogFormVisible = true
				this.forminfo = e
			},
			submitForm() {
				this.getuserlist()
			},
			handleChangePage(val){
				this.page = val
				this.getuserlist()
			}
			
		}
	};
</script>

<style lang="less" scoped>
	.runmoney{
		display: flex; 
		flex-direction: column;
		align-items: center;
		ul{
			display: flex;
			li{
				text-align: center;
				margin: 0 20px;
			}
		}
	}
	
</style>
